<template>
  <div>
    <SfHeading :level="4" :title="$t('Import from CSV')" class="sf-heading--left" />
    <SfInput
      name="csv"
      type="file"
      ref="csv"
      v-model="csv"
      :placeholder="$t('CSV')"
      :aria-label="$t('CSV')"
      @change="handleFilesChange"
    />
    <p class="text-danger" v-if="showLimit">
      {{ $t("Max 100 items.") }}
    </p>
    <SfLink href="/cart.csv">{{ $t("Download example import") }}</SfLink>
    <SfButton
      class="fz-input-button__button sf-button--outline sf-button--full-width"
      :disabled="files && !files.length"
      @click.prevent="importCsv"
    >
      {{ $t("Import cart") }}
    </SfButton>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { parse } from 'papaparse';
import {
  SfLink, SfButton, SfInput, SfHeading,
} from '@storefront-ui/vue';

export default {
  name: 'CsvCart',
  components: {
    SfButton,
    SfInput,
    SfHeading,
    SfLink,
  },
  data() {
    return {
      csv: '',
      files: [],
      showLimit: false,
    };
  },
  methods: {
    handleFilesChange(evt) {
      this.files = evt.target.files;
      this.showLimit = false;
    },
    importCsv() {
      if (!this.files.length) return;

      parse(this.files[0], {
        header: true,
        complete: (res) => {
          console.log(res, 'res');
          if (res?.errors.length) {
            alert(res?.errors[0].message);
            return;
          }

          if (res?.data && res?.data.length > 100) {
            this.showLimit = true;
            return;
          }

          console.log('data:', res?.data);

          const itemsToSave = res?.data.filter(({ sku, quantity }) => sku && quantity);

          if (!itemsToSave.length) {
            alert(this.$t('Wrong format, please download example import'));
            return;
          }

          this.addItemsFromCsvToCart(itemsToSave).then(() => {
            this.fetchCart();
            this.csv = '';
          });
        },
      });
    },
    ...mapActions({
      addItemsFromCsvToCart: 'checkout/addItemsFromCsvToCart',
      fetchCart: 'checkout/fetchCart',
    }),
  },
};
</script>

<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/helpers";
@import "src/scss/_breakpoint";

.sf-heading {
  @include flexbox-desktop {
    margin-bottom: var(--spacer-sm);
  }
}

.sf-button--outline {
  --button-border-color: var(--_c-gray-secondary);
  --button-color: var(--_c-gray-secondary);
}
</style>
